import { Component, OnInit, Input, Output } from '@angular/core';
import {
  Validators,
  FormControl,
  FormGroup,
  FormBuilder,
} from '@angular/forms';
import { BikeService } from '../../../services/bike.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ComponentEditComponent } from '../../modals/component-edit/component-edit.component';
import { WriteLogsService } from '../../../services/write-logs.service';
import { PageViews } from '../../../enums/page-views.enum';
import { LookupService } from '../../../services/lookup.service';
import { HelpersService } from '../../../services/helpers.service';
import { ServiceRequestService } from '../../../services/servicerequest.service';
import { GearManagementService } from '../../../services/gear-management.service';
import { UpdateJobcardComponent } from '../../modals/update-jobcard/update-jobcard.component';
import { TranslateService } from '@ngx-translate/core';
import { NewJobcardService } from '../../../services/new-jobcard.service';
import EventEmitter from 'events';

@Component({
  selector: 'app-bike',
  templateUrl: './bike.component.html',
  styleUrls: ['./bike.component.scss'],
})
export class BikeComponent implements OnInit {
  @Input() jobcard;
  @Input() partnerID;
  @Input() bike;
  @Input() bikeGear;
  @Input() useNew = false;



  public BikeForm: FormGroup;
  public loading = false;
  public updating = false;
  public services: any = [];
  public editBike: boolean = false;
  public manufacturers: any = [];
  public models: any = [];
  public distanceMetric = 'km';
  public countryData: any = {};
  public bikeTypes: any = [];
  public partner: any = {};

  constructor(
    private helpersService: HelpersService,
    public bikeService: BikeService,
    private lookupService: LookupService,
    private modalService: NgbModal,
    private writeLogsService: WriteLogsService,
    private serviceRequest: ServiceRequestService,
    private gearService: GearManagementService,
    private fb: FormBuilder,
    private translate: TranslateService,
    private newJobcardService: NewJobcardService,
  ) {
    this.distanceMetric = this.helpersService.getDistanceMetric();
  }

  ngOnInit() {
    this.countryData = this.helpersService.getCountryData();
    this.partner = this.helpersService.getPartnerData();
    this.sort();
    this.getServiceLogs();
    this.refreshBike();
    this.getBikeTypes();
    this.bikeGear = this.bikeGear.filter((b) => {
      return b.status === 'Active';
    });

    if (this.jobcard && this.jobcard.ID) {
      this.writeLogsService
        .writeLog(PageViews.BIKE_TAB, this.jobcard.ID)
        .subscribe((result) => {});
    }
  }

  getBikeTypes() {
    this.gearService.getBikeTypes().subscribe((types) => {
      this.bikeTypes = types.map((x) => {
        return { value: x.id, label: this.translate.instant(x.label) };
      });
    });
  }

  refreshBike() {
    //Just refreshing the components etc for the bike
    this.bikeService.getBike(this.bike.ID).subscribe((bike) => {
      this.bike = bike;
      console.log(this.bike);
    });
    this.bikeService.getActiveGear(this.bike.ID).subscribe((bikeGear) => {
      this.bikeGear = bikeGear.filter((b) => {
        return b.status === 'Active';
      });
      this.sort();
    });
  }

  sort() {
    this.bikeGear = this.bikeGear.sort(function (a, b) {
      return a.serviceScore > b.serviceScore ? 1 : -1;
    });
  }

  getServiceLogs() {
    this.loading = true;
    this.bikeService.getServiceLogs(this.bike.ID).subscribe((services) => {
      this.services = services;
      this.services = services
        .sort(function (a, b) {
          var dateA = new Date(a.DateCheckedIn),
            dateB = new Date(b.DateCheckedIn);
          return dateB.getTime() - dateA.getTime();
        })
        .filter((service) => {
          return (
            (service.StatusDescription === 'Collected' ||
              service.StatusDescription === 'Ready for Collection') &&
            service.PartnerID === this.partner.ID
          );
        });
      this.loading = false;
    });
  }

  addNewComponent() {
    const modalRef = this.modalService.open(ComponentEditComponent, {
      backdrop: 'static',
      size: 'lg',
      windowClass: 'component-modal',
    });
    modalRef.componentInstance.gear = { BikeID: this.bike.ID, TypeID: 0 };
    modalRef.componentInstance.distanceMetric = this.distanceMetric;
    modalRef.result.then(
      (result) => {
        if (result && result.updated) {
          this.refreshBike();
        }
      },
      (onrejected) => {},
    );
  }

  searchManufacturer(event) {
    this.lookupService
      .getManufacturerLookup(event.query)
      .subscribe((manufacturers) => {
        this.manufacturers = manufacturers.map((item) => {
          return item.Description;
        });
      });
  }

  searchModel(event) {
    this.lookupService
      .getModelLookup(this.BikeForm.controls['Manufacturer'].value, event.query)
      .subscribe((models) => {
        this.models = models.map((item) => {
          return item.Description;
        });
      });
  }

  setupEditBike() {
    this.editBike = true;
    this.BikeForm = this.fb.group({
      Manufacturer: new FormControl(
        this.bike.Manufacturer,
        Validators.required,
      ),
      Model: new FormControl(this.bike.Model, Validators.required),
      Colour: new FormControl(this.bike.Colour, Validators.nullValidator),
      SerialNo: new FormControl(this.bike.SerialNo, Validators.nullValidator),
      ModelYear: new FormControl(this.bike.ModelYear, Validators.nullValidator),
      BikeSize: new FormControl(this.bike.BikeSize, Validators.nullValidator),
      TypeID: new FormControl(this.bike.TypeID, Validators.required),
    });
  }

  updateBike(bike) {
    this.updating = true;
    var bikeUpdate = { ...this.bike, ...bike, ModelYear: bike.ModelYear || 0 };
    this.bikeService.saveBike(bikeUpdate).subscribe(
      (updatedBike) => {
        console.log(updatedBike);
        this.bike = updatedBike;
        if(this.jobcard && this.bike.SerialNo){
          this.jobcard.SerialNo = this.bike.SerialNo;
        }
        this.editBike = false;
        this.updating = false;
      },
      (err) => {
        this.updating = false;
      },
    );
  }

  openJobcard(service) {

    if (this.helpersService.getPartnerData().UseNewJobCard) {
      this.newJobcardService.openManageJobCard(service.ID, {
        onRefreshEvents: () => { }
      });

      return;
    }

    if (
      service.PartnerID === this.partnerID &&
      service.ID !== this.jobcard.ID
    ) {
      this.serviceRequest
        .getServiceRequestData(service.ID)
        .subscribe((jobcard) => {
          const modalRef = this.modalService.open(UpdateJobcardComponent, {
            size: 'lg',
            backdrop: 'static',
            windowClass: 'jobcard-modal',
          });
          modalRef.componentInstance.jobcard = jobcard;
          modalRef.componentInstance.partnerID = this.partnerID;
          modalRef.result.then(
            (result) => {},
            (onrejected) => {},
          );
        });
    }
  }

  getBikeType(typeID) {
    var type = this.bikeTypes
      .filter((x) => {
        return x.value === typeID;
      })
      .pop();
    if (type) {
      return type.label;
    } else {
      return this.bike.Type;
    }
  }
}
